import React, { Component } from 'react';
import {Link} from 'react-router-dom'
import { connect } from 'react-redux';
import { do_action } from '../../actions';
import {convertPrice, convertPriceNumber} from '../../utils/convert'
import Pagination from '../Common/Pagination';
import {formartDateTime} from '../../utils/date';
import Spinner from 'react-spinkit'

class Quotes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allQuotes: [],
            listPrice: [],
            total: 0,
            number_page: 1,
            page: 1,
            limit: 10,
            loading: true
        }
    }

    componentWillMount() {
        let {vendor} = this.props;
        if (vendor._id) {
            this.getQuotesByPage(vendor._id, 1, vendor.type);
        }
    }

    componentDidMount() {
        $('.modal-backdrop').remove();
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.vendor && (!this.props.vendor || (this.props.vendor && nextProps.vendor._id != this.props.vendor._id))) {
            let vendor_id = nextProps.vendor._id;
            let type = nextProps.vendor.type;

            this.getQuotesByPage(vendor_id, 1, type);
        }
    }

    getQuotesByPage(vendor_id, page, type) {
        let {limit} = this.state;
        let urlQuote = 'get_quote_of_vendor'
        if (type == 'designer') urlQuote = 'get_live_bid_of_designer'
        if (type == 'pm') urlQuote = 'get_live_bid_of_pm'

        this.setState({
            loading: true
        })
        do_action(urlQuote, { vendor: vendor_id, page, limit })
            .then(data => {

                this.setState({
                    loading: false
                })

                if (data.signal) {
                    let {listQuotes, listPrice, total, number_page} = data.data;
                    this.setState({
                        allQuotes: listQuotes,
                        listPrice,
                        total: total,
                        number_page: number_page,
                        page
                    });
                }
            })
            .catch(err => {
                this.setState({
                    loading: false
                })
            });
    }

    clickPage(page) {
        let {vendor} = this.props;
        this.getQuotesByPage(vendor._id, page, vendor.type);
    }

    renderStatus(status) {
        switch (status) {
            case 0: 
                return <td className="text-primary-kt w-15">Live Bid</td>;
            case 1:
                return <td className="text-success-kt w-15">Accept</td>;
            case -1:
                return <td className="text-danger-kt w-15">Decline</td>;
            case -2:
                return <td className="w-15">Client Cancel</td>;
            default:
                return <td className="text-success-kt w-15">Approved</td>

        }
    }

    renderQuotes() {
        let {allQuotes, listPrice, loading} = this.state;

        if (loading) {
            return (
                <div className="row text-center bg-white">
                    <Spinner name="line-scale-pulse-out-rapid" color="steelblue"/>
                </div>
            )
        }

        if (!loading && !allQuotes.length) {
            return (
                <div className="row text-center bg-white">
                    <h4>You don't have any live bids</h4>
                </div>
            )
        }

        let content = allQuotes.map((quotes, idx) => {
            let customer = quotes.quotes.customer;
            let name = customer ? `${customer.first_name} ${customer.last_name}` : '';
            let price = listPrice[idx] || 0;
            return (
                <tr key={`quotes-${idx}`}>
                    <td className="w-30">{formartDateTime(quotes.quotes.updated_at)}</td>
                    <td className="w-20">{name}</td>
                    <td className="text-primary-kt fontSemiBold w-20">{`$${convertPriceNumber(price)}`}</td>
                    {this.renderStatus(quotes.state)}
                    <td className="text-center w-15"><Link to={`/quotes/detail/${quotes.quotes._id}`} className="action-view">Detail</Link></td>
                </tr>
            );
        })

        return (
            <div className="form-group table-responsive table-kt">
                <table className="table">
                    <thead>
                        <tr>
                            <th className="w-30">
                                Date    
                            </th>
                            <th className="w-20">
                                Client    
                            </th>
                            <th className="w-20">
                                Amount    
                            </th>
                            <th className="w-15">
                                Status    
                            </th>
                            <th className="text-center w-15">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {content}
                    </tbody>
                </table>
            </div>
        )
    }

    render() {
        let {total, number_page, page} = this.state;
        return (
            <div className="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 maindb">
                <div className="form-group clearfix">
                    <div className="pull-left">
                        <h3 className="marginT0">Live Bids</h3>
                    </div>
                </div>
                
                {this.renderQuotes()}

                <Pagination page={page} number_page={number_page} clickPage={this.clickPage.bind(this)}/>

            </div>
        );
    }
}

function mapStateToProps(state) {
    const {vendor} = state;
    return { 
        vendor
    }
}

export default connect(mapStateToProps)(Quotes);